export default __webpack_public_path__ + "static/media/hellow.3faced94.jpg";